import { useTranslation } from '../i18n';

/** Reports the server's public-catalog decision without inferring policy from lifecycle colors. */
export function PublicVisibilityBadge({ publiclyListed }: { publiclyListed?: boolean }) {
    const t = useTranslation();
    if (publiclyListed !== false) return null;
    return (
        <span
            title={t('visibility.restrictedExplanation')}
            class="inline-flex max-w-full rounded border border-state-failed/50 bg-state-failed/10 px-2 py-0.5 font-mono text-[10px] font-normal not-italic leading-normal text-state-failed"
        >
            {t('visibility.hiddenFromCatalog')}
        </span>
    );
}
